(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ResourcesController', ResourcesController);

    ResourcesController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader'];

    function ResourcesController($scope, $state, translate, translatePartialLoader) {
        var vm = this;

    }
})();

